export const animalsReducer = (state = {loading: false, resultanimal: null, animals: [], animalsForSelect: [], animal: null, total: 0} , action) => {
    switch (action.type) {
        case 'ANIMAL_GETALL_SUCCESS':
            return {
                ...state,
                loading: false,
                animals: action.payload.animals,
                total: action.payload.total
            }
        case 'ANIMAL_GETALLFORSELECT_SUCCESS':
            return {
                ...state,
                animalsForSelect: action.payload
            }
        case 'ANIMAL_GET_SUCCESS':
            return {
                ...state,
                loading: false,
                animal: action.payload.animal
            }
        case 'ANIMAL_ADD_SUCCESS':
            return {
                ...state,
                loading: false,
                resultanimal: action.payload.message,
                animal: action.payload.animal,
                animals: [...state.animals, action.payload.animal],
            }
        case 'ANIMAL_WRONG_SUCCESS':
            return {
                ...state,
                loading: false,
                resultanimal: action.payload.message
            }
        case 'ANIMAL_EDIT_SUCCESS':
            if(action.payload.animal){
                return {
                    ...state,
                    loading: false,
                    resultanimal: action.payload.message,
                    animal: action.payload.animal,
                    animals: state.animals.map(animal => animal._id === action.payload.animal._id ? action.payload.animal : animal),
                }
            }else{
                return {
                    ...state,
                    loading: false,
                    resultanimal: action.payload
                }
            }
        case 'ANIMAL_RESET_RESULT':
            return {
                ...state,
                resultanimal: null
            }
        case 'ANIMAL_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'ANIMAL_NOT_LOADING':
            return {
                ...state,
                loading: false
            }
        default:
            return state
    }
}
